import { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { DeleteProjectLinesAPI, GetAllProjectGroupingLinesByCompanyIdAPI, GetAllProjectLinesByCompanyIdAPI, GetAllYearsInRecommendation, GetQtdProjAndLinesAPI } from '../../../API/RecommendationAPI';
import CardHeader from '../../components/CardHeader';
import useLoading from '../../../Hooks/useLoading';
import { ProjectModel } from '../../../Models/ProjectModel';
import { LinesModel } from '../../../Models/LinesModel';
import { ProjectGroupingModel } from '../../../Models/ProjectGroupingModel';
import { CompanyContext } from '../../../Contexts/CompanyContext';
import { GetAllFutureProjectsAPI } from '../../../API/ProjectsAPI';
import { IResponseProps } from '../../../Interfaces/IResponseProps';
import { getAllGroupingPaginatedByCompanyIdAPI } from '../../../API/ProjectGroupingAPI';
import { SortDesc } from '../../../Utils/SortYear';
import PaginationTabs from '../../components/PaginationTabs';
import { AutoComplete, AutoCompleteProps, Button, Input, PaginationProps, Space, Table, TableProps, Modal } from 'antd';
import ModalDelete from "../../components/ModalDelete";
import { EyeOutlined, DeleteOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './styles.css';

export default function Recommendation() {
    const { loading, toggleLoading } = useLoading();
    const [pag, setPag] = useState<number>(0);
    const [assignedFutureProject, setAssignedFutureProject] = useState<number>(0);
    const [yearFilter, setYearFilter] = useState<number>(0);
    const [totalLines, setTotal] = useState<number>(0);
    const [years, setYears] = useState<number[]>([]);
    const [projects, setProjects] = useState<ProjectModel[]>([]);
    const [Lines, setLines] = useState<LinesModel[]>([]);
    const [assignedLines, setAssignedLines] = useState<number>(0);
    const [assignedProjects, setAssignedProjects] = useState<number>(0);
    const [search, setSearch] = useState<string>("");
    const [menu, setMenu] = useState<string[]>(["Todos"]);
    const [projectGrouping, setProjectGrouping] = useState<ProjectGroupingModel[]>([]);
    const [options, setOptions] = useState<AutoCompleteProps['options']>([]);
    const { company } = useContext(CompanyContext);
    const menuDefault = [company.potential === 0 ? "Projetos" : "Agrupamentos", "Linhas"];
    const navigate = useNavigate();
    const [take, setTake] = useState<number>(7);
    const [showdeleteModal, setShowDeleteModal] = useState(false);
    const [selectedLine, setSelectedLine] = useState<LinesModel | null>(null);
    const [deleteResponse, setDeleteResponse] = useState(false);


    useEffect(() => {
        if (deleteResponse && selectedLine) {
            handleDeleteLine(selectedLine);
        }
    }, [deleteResponse]);

    const openDeleteModal = (record: LinesModel) => {
        setSelectedLine(record);
        setShowDeleteModal(true);
    };
    const getAllProjects = async (page?: number) => {
        try {
            toggleLoading(true);
            let text = search === null || search === "" ? "all" : search;

            await GetAllFutureProjectsAPI(company.id, yearFilter, page ?? 1, take, text).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    setProjects(resp.data.items);
                    setTotal(resp.data.total);
                }
            }).finally(() => {
                toggleLoading(false);
            });
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    const getAllProjectGrouping = async (page?: number) => {
        try {
            toggleLoading(true);

            var text = search && search !== "" ? search : "\"\"";
            await getAllGroupingPaginatedByCompanyIdAPI(company.id, page ?? 1, take, text, yearFilter === 0 ? "all" : years[yearFilter! - 1].toString()).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    setProjectGrouping(resp.data.items);
                    setTotal(resp.data.total);
                }
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    const getAllYears = async () => {
        try {
            toggleLoading(true);

            await GetAllYearsInRecommendation(company.id).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    var info = resp.data;
                    var length = info.length;
                    var all = ["Todos"];
                    if (length > 0) {
                        info = SortDesc(info);
                        for (var i = 0; i < length; i++) {
                            all.push(info[i]);
                        }
                    }
                    setMenu(all);
                    setYears(info);
                }
            }).finally(() => {
                toggleLoading(false);
            });
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    const getAllLines = async (page?: number) => {
        try {
            toggleLoading(true);

            let text = search === null || search === "" ? "all" : search;
            if (company.potential === 0) {
                await GetAllProjectLinesByCompanyIdAPI(company.id, page ?? 1, take, text).then((resp: IResponseProps) => {
                    if (resp.statusCode === 200) {
                        setLines(resp.data.items);
                        setTotal(resp.data.total);
                    }
                }).finally(() => toggleLoading(false));
            }
            else {
                await GetAllProjectGroupingLinesByCompanyIdAPI(company.id, page ?? 1, take, text).then((resp: IResponseProps) => {
                    if (resp.statusCode === 200) {
                        setLines(resp.data.items);
                        setTotal(resp.data.total);
                    }
                }).finally(() => toggleLoading(false));
            }
        } catch (error: any) {
            toggleLoading(false);
            toast.error(error);
        }
    }

    const getQtdLinesAndProjects = async () => {
        try {
            toggleLoading(true);

            await GetQtdProjAndLinesAPI(company.id).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    setAssignedLines(resp.data[0]);
                    setAssignedProjects(resp.data[1]);
                    setAssignedFutureProject(resp.data[2]);
                }
            }).finally(() => toggleLoading(false));
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    const handleDeleteLine = async (record: LinesModel) => {
        try {
            toggleLoading(true);

            if (!record.projectId) {
                throw new Error("ProjectId não está disponível no registro");
            }
            await DeleteProjectLinesAPI(
                record.projectId,
                record.id,
                company.id
            ).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    toast.success("Linha removida com sucesso");
                    getAllLines();
                }
            });
        } catch (error: any) {
            toast.error(error.message || "Erro ao remover linha");
        } finally {
            toggleLoading(false);
            setSelectedLine(null);
            setDeleteResponse(false);
        }
    }

    function tabChanged(key: string) {
        setPag(parseInt(key));
    }

    function tabChangedYears(key: string) {
        setYearFilter(key == "0" ? 0 : parseInt(menu[parseInt(key)]));
    }

    function goToProjects(id: string) {
        navigate(`/recommendations/ProjectLines/${company.id}/${id}`);
    }

    function goToProjectGrouping(id: string) {
        navigate(`/recommendations/ProjectGroupingLines/${company.id}/${id}`);
    }

    function goToFavGrants(id: string) {
        navigate(`/recommendations/ProjectsAssigned/${company.id}/${id}`);
    }

    useEffect(() => {
        getAllYears();
        getQtdLinesAndProjects();
        getAllLines();
    }, []);

    useEffect(() => {
        if (pag === 0) {
            if (company.potential === 0) {
                getAllProjects();
            } else {
                getAllProjectGrouping();
            }
        } else {
            getAllLines();
        }
    }, [pag, yearFilter, take]);

    const ProjectRecommendationColumns: TableProps<ProjectModel>['columns'] = [
        {
            key: "name",
            dataIndex: "name",
            showSorterTooltip: { target: 'full-header' },
            filters: projects.map(item => ({
                text: item.name,
                value: item.name,
            })),
            title: "",
            width: '50%'
        },
        {
            key: "budget",
            dataIndex: "budget",
            title: "",
            showSorterTooltip: { target: 'full-header' },
            render: (value, row, index) => {
                return <span>R$ {value.toLocaleString('pt-BR')}</span>;
            },
        },
        {
            key: "name",
            dataIndex: "name",
            title: "Ações",
            width: '5%',
            render: (_, record) => (
                <Space size="small">
                    <Button type="text" size="small" onClick={() => goToProjects(record.id)}><EyeOutlined className="blue" /></Button>
                </Space>
            ),
        },
    ];

    const ProjectGroupingRecommendation: TableProps<ProjectGroupingModel>['columns'] = [
        {
            key: "name",
            dataIndex: "name",
            showSorterTooltip: { target: 'full-header' },
            filters: projectGrouping.map(item => ({
                text: item.name,
                value: item.name,
            })),
            title: "",
            width: '50%'
        },
        {
            key: "totalBudget",
            dataIndex: "totalBudget",
            title: "",
            showSorterTooltip: { target: 'full-header' },
            render: (value, row, index) => {
                return <span>R$ {value.toLocaleString('pt-BR')}</span>;
            },
        },
        {
            key: "name",
            dataIndex: "name",
            title: "Ações",
            width: '5%',
            render: (_, record) => (
                <Space size="small">
                    <Button type="text" size="small" onClick={() => goToProjectGrouping(record.id)}><EyeOutlined className="blue" /></Button>
                </Space>
            ),
        },
    ];

    const FavGrantsRecommendation: TableProps<LinesModel>['columns'] = [
        {
            key: "favoritesGrantsName",
            dataIndex: "favoritesGrantsName",
            showSorterTooltip: { target: 'full-header' },
            filters: Lines.map(item => ({
                text: item.favoritesGrantsName,
                value: item.favoritesGrantsName,
            })),
            title: "",
            width: '50%'
        },
        {
            key: "favoritesGrantsName",
            dataIndex: "favoritesGrantsName",
            title: "Ações",
            width: '5%',
            render: (_, record) => {
                console.log("Registro completo:", record);

                return (
                <Space size="small">
                    <Button type="text" size="small" onClick={() => goToFavGrants(record.id)}><EyeOutlined className="blue" /></Button>
                    <Button type="text" size="small" onClick={() => openDeleteModal(record)} loading={loading} danger><DeleteOutlined className="red" /></Button>
                </Space>
                );
            },
        },
    ];

    return (
        <div className='card ms-2 me-2'>
            <CardHeader
                pageName="Recomendação"
                hasPageBefore={false}
            />
            <ModalDelete
                show={showdeleteModal}
                toggleShow={() => setShowDeleteModal(false)}
                setResponse={setDeleteResponse}
                itemName={`linha: "${selectedLine?.favoritesGrantsName || ''}"`}
            />
            <div className='card-body mt-4'>
                {company.potential === 0 ?
                    <div className='d-flex align-items-center mb-4'>
                        <div className='card-lines-info-container d-flex align-items-center justify-content-center'>Linhas Atribuídas: <b className='ms-2'>{assignedLines}</b></div>
                        <div className='card-lines-info-container ms-2 me-2 d-flex align-items-center justify-content-center'>Projetos Futuros: <b className='ms-2'>{assignedFutureProject}</b></div>
                        <div className='card-lines-info-container me-2 d-flex align-items-center justify-content-center'>Projetos Cadastrados: <b className='ms-2'>{assignedProjects}</b></div>
                        <AutoComplete
                            popupMatchSelectWidth={true}
                            options={options}
                            onSelect={(value: string) => { }}
                            size='large'
                            className="w-100 h-100 pe-0"
                            onSearch={(val) => { setSearch(val) }}
                        >
                            <Input.Search
                                onBlur={() => getAllProjects()}
                                showCount={false}
                                className="white h-100"
                                size='large'
                                loading={loading}
                                placeholder={pag === 0 ? "Pesquisar por Projetos..." : "Pesquisar por Linhas..."}
                                enterButton
                            />
                        </AutoComplete>
                    </div>
                    :
                    <div className='d-flex align-items-center mb-4'>
                        <div className='card-lines-info-container d-flex align-items-center justify-content-center'>Linhas Atribuídas: <b className='ms-2'>{Lines.length}</b></div>
                        <div className='card-lines-info-container ms-2 me-2 d-flex align-items-center justify-content-center'>Projetos Cadastrados: <b className='ms-2'>{assignedProjects}</b></div>
                        <div className='card-lines-info-container me-2 d-flex align-items-center justify-content-center'>Total de Agrupamentos: <b className='ms-2'>{projectGrouping.length}</b></div>
                        <AutoComplete
                            popupMatchSelectWidth={true}
                            options={options}
                            size='large'
                            onSelect={(value: string) => { }}
                            className="w-100 h-100 pe-0"
                            onSearch={(val) => { setSearch(val) }}
                        >
                            <Input.Search
                                onBlur={() => getAllProjectGrouping()}
                                showCount={false}
                                className="white h-100"
                                size='large'
                                loading={loading}
                                placeholder={`pesquisar por agrupamentos...`}
                                enterButton
                            />
                        </AutoComplete>
                    </div>
                }
                <div className='d-flex align-items-end justify-content-between '>
                    <PaginationTabs onChange={tabChanged} tabs={menuDefault} />
                    {pag === 0 &&
                        <div className=''>
                            <PaginationTabs onChange={tabChangedYears} tabs={menu} />
                        </div>
                    }
                </div>
                <div>
                    {pag === 0 ? company.potential === 0 ?
                        <Table
                            loading={loading}
                            showHeader={false}
                            rowKey="id"
                            pagination={{
                                pageSizeOptions: ['7', '10', '25', '50', '75', '100'],
                                showSizeChanger: true,
                                total: totalLines,
                                showTotal: (total) => `Total ${total} items`,
                                pageSize: take,
                                onChange: (page, pageSize) => {
                                    getAllProjects(page);
                                },
                                onShowSizeChange: (page, size) => {
                                    setTake(size)
                                }
                            }}
                            dataSource={projects}
                            columns={ProjectRecommendationColumns}
                        />
                        :
                        <Table
                            loading={loading}
                            showHeader={false}
                            rowKey="id"
                            pagination={{
                                pageSizeOptions: ['7', '10', '25', '50', '75', '100'],
                                showSizeChanger: true,
                                total: totalLines,
                                pageSize: take,
                                showTotal: (total) => `Total ${total} items`,
                                onChange: (page, pageSize) => {
                                    getAllProjectGrouping(page);
                                },
                                onShowSizeChange: (page, size) => {
                                    setTake(size)
                                }
                            }}
                            dataSource={projectGrouping}
                            columns={ProjectGroupingRecommendation}
                        />
                        :
                        <Table
                            loading={loading}
                            showHeader={false}
                            rowKey="id"
                            pagination={{
                                pageSizeOptions: ['7', '10', '25', '50', '75', '100'],
                                showSizeChanger: true,
                                total: totalLines,
                                pageSize: take,
                                showTotal: (total) => `Total ${total} items`,
                                onChange: (page, pageSize) => {
                                    getAllLines(page);
                                },
                                onShowSizeChange: (page, size) => {
                                    setTake(size)
                                }
                            }}
                            dataSource={Lines}
                            columns={FavGrantsRecommendation}
                        />
                    }
                </div>
            </div>
        </div>
    )
}